"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.saveTableSettings = void 0;
var server_1 = require("../../../../helpers/server");
var LoginActions_1 = require("./LoginActions");
// Initial state values
var initialState = {
    token: null,
    user: null,
    workTypes: null,
    workTypesVersion: '',
};
exports.default = (function (state, action) {
    var _a, _b, _c, _d;
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case (0, server_1.apiActions)(LoginActions_1.LoginActions.LOGIN).request:
            return __assign(__assign({}, state), { token: null });
        case (0, server_1.apiActions)(LoginActions_1.LoginActions.LOGIN).success:
            var newState = __assign(__assign({}, state), { isLoading: false, token: action.payload.token, user: action.payload.user, workTypes: ((_b = (_a = action.payload) === null || _a === void 0 ? void 0 : _a.workTypes) === null || _b === void 0 ? void 0 : _b.values) || null, workTypesVersion: ((_d = (_c = action.payload) === null || _c === void 0 ? void 0 : _c.workTypes) === null || _d === void 0 ? void 0 : _d.version) || '' });
            return newState;
        case (0, server_1.apiActions)(LoginActions_1.LoginActions.PROFILE_UPDATE).success:
            return __assign(__assign({}, state), { user: action.payload.result });
        case LoginActions_1.LoginActions.LOGOUT:
            return __assign({}, initialState);
        default:
            return state;
    }
});
var saveTableSettings = function (localProps, key, setting) {
    var _a;
    var _b;
    var currentTableSettings = ((_b = localProps.identity) === null || _b === void 0 ? void 0 : _b.tableSettings) || null;
    var keySettings = __assign(__assign({}, currentTableSettings === null || currentTableSettings === void 0 ? void 0 : currentTableSettings[key]), setting);
    var tableSettings = __assign(__assign({}, currentTableSettings), (_a = {}, _a[key] = keySettings, _a));
    var user = { tableSettings: tableSettings };
    localProps.updateTableSettings(localProps.identity._id, user);
};
exports.saveTableSettings = saveTableSettings;
